import _newArrowCheck from "@babel/runtime/helpers/newArrowCheck";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
/**
 * inputevent - Alleviate browser bugs for input events
 * https://github.com/marcandre/inputevent
 * @version v0.0.3 - (built Thu, Apr 14th 2016, 5:58 pm)
 * @author Marc-Andre Lafortune <github@marc-andre.ca>
 * @license MIT
 */

import $ from 'jquery';
function InputEvent() {
  var _this = this;
  var globals = window || global;

  // Slightly odd way construct our object. This way methods are force bound.
  // Used to test for duplicate library.
  Object.assign(this, {
    // For browsers that do not support isTrusted, assumes event is native.
    isNativeEvent: function isNativeEvent(evt) {
      _newArrowCheck(this, _this);
      return evt.originalEvent && evt.originalEvent.isTrusted !== false;
    }.bind(this),
    fakeInputEvent: function fakeInputEvent(evt) {
      _newArrowCheck(this, _this);
      if (this.isNativeEvent(evt)) {
        $(evt.target).trigger('input');
      }
    }.bind(this),
    misbehaves: function misbehaves(evt) {
      _newArrowCheck(this, _this);
      if (this.isNativeEvent(evt)) {
        this.behavesOk(evt);
        $(document).on('change.inputevent', evt.data.selector, this.fakeInputEvent);
        this.fakeInputEvent(evt);
      }
    }.bind(this),
    behavesOk: function behavesOk(evt) {
      _newArrowCheck(this, _this);
      if (this.isNativeEvent(evt)) {
        $(document) // Simply unbinds the testing handler
        .off('input.inputevent', evt.data.selector, this.behavesOk).off('change.inputevent', evt.data.selector, this.misbehaves);
      }
    }.bind(this),
    // Bind the testing handlers
    install: function install() {
      _newArrowCheck(this, _this);
      if (globals.inputEventPatched) {
        return;
      }
      globals.inputEventPatched = '0.0.3';
      for (var _i = 0, _arr = ['select', 'input[type="checkbox"]', 'input[type="radio"]', 'input[type="file"]']; _i < _arr.length; _i++) {
        var selector = _arr[_i];
        $(document).on('input.inputevent', selector, {
          selector: selector
        }, this.behavesOk).on('change.inputevent', selector, {
          selector: selector
        }, this.misbehaves);
      }
    }.bind(this),
    uninstall: function uninstall() {
      _newArrowCheck(this, _this);
      delete globals.inputEventPatched;
      $(document).off('.inputevent');
    }.bind(this)
  });
}
;
export default new InputEvent();